import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { FieldType } from '@ngx-formly/core';

@Component({
	selector: 'formly-field-checkbox-group',
	template: `
		<div [attr.data-test-id]="field.id" class="my-3">
			<vp-checkbox-group
				[customFormControl]="checkBoxFormControl"
				[disabled]="props.disabled"
				[hasError]="showError"
				[horizontal]="props['horizontal']"
				[initialValue]="formControl.value"
				[inputId]="field.id"
				[isOptional]="props['optional']"
				[isRequired]="props.required"
				[isValid]="
					props['optional'] && !formControl.value
						? null
						: formControl.valid
				"
				[name]="field.key.toString()"
				[options]="props['checkboxOptions']"
				[readonly]="props.readonly"
				[shouldTranslate]="props['translate']"
				ngDefaultControl
			/>
		</div>
	`,
	standalone: false,
})
export class CheckboxGroupComponent extends FieldType implements OnInit {
	checkBoxFormControl: FormControl;

	ngOnInit(): void {
		this.checkBoxFormControl = this.formControl as FormControl;
	}
}
